(() => {
  const root = document.documentElement;
  let theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  const update = () => {
    root.dataset.theme = theme;
    document.querySelectorAll('.ch-theme-toggle').forEach(button => {
      const next = theme === 'dark' ? 'light' : 'dark';
      button.textContent = next === 'dark' ? button.dataset.darkLabel : button.dataset.lightLabel;
      button.setAttribute('aria-label', button.textContent);
      button.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('.ch-theme-toggle')) {
      theme = theme === 'dark' ? 'light' : 'dark';
      update();
    }
  });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('error', event => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.closest('#cozy-coming-soon')) return;
    const fallback = document.createElement('div');
    fallback.className = 'ch-image-fallback';
    fallback.setAttribute('role', 'img');
    fallback.setAttribute('aria-label', image.alt);
    fallback.textContent = image.alt;
    image.replaceWith(fallback);
  }, true);
  update();
})();
